var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRactangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_421)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 0C24.4796 7.75803 30.7603 14.0467 38.5084 14.0467C30.7603 14.0467 24.4796 20.3354 24.4796 28.0934C24.4796 20.3354 18.1989 14.0467 10.4507 14.0467C18.1989 14.0467 24.4796 7.75803 24.4796 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 29,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 0C24.4796 7.75803 30.7603 14.0467 38.5084 14.0467C30.7603 14.0467 24.4796 20.3354 24.4796 28.0934C24.4796 20.3354 18.1989 14.0467 10.4507 14.0467C18.1989 14.0467 24.4796 7.75803 24.4796 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5111 0H32.8979V28.0961H38.5111V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8981 0H27.2849V28.0961H32.8981V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2875 0H21.6743V28.0961H27.2875V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6744 0H16.0613V28.0961H21.6744V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0612 0H10.448V28.0961H16.0612V0Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.987 19.6534C36.987 23.5338 40.1273 26.6782 44.0028 26.6782C40.1273 26.6782 36.987 29.8225 36.987 33.7029C36.987 29.8225 33.8466 26.6782 29.9712 26.6782C33.8466 26.6782 36.987 23.5338 36.987 19.6534Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_203_421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 19,
    width: 16,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.987 19.6534C36.987 23.5338 40.1273 26.6782 44.0028 26.6782C40.1273 26.6782 36.987 29.8225 36.987 33.7029C36.987 29.8225 33.8466 26.6782 29.9712 26.6782C33.8466 26.6782 36.987 23.5338 36.987 19.6534Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_203_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 19.6534H41.1948V33.7002H44.0001V19.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1949 19.6534H38.3896V33.7002H41.1949V19.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3897 19.6534H35.5845V33.7002H38.3897V19.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5816 19.6534H32.7764V33.7002H35.5816V19.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7764 19.6534H29.9712V33.7002H32.7764V19.6534Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6822 30.9753C26.6822 32.9155 28.2524 34.4877 30.1901 34.4877C28.2524 34.4877 26.6822 36.0599 26.6822 38C26.6822 36.0599 25.112 34.4877 23.1743 34.4877C25.112 34.4877 26.6822 32.9155 26.6822 30.9753Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_203_421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 30,
    width: 8,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6822 30.9753C26.6822 32.9155 28.2524 34.4877 30.1901 34.4877C28.2524 34.4877 26.6822 36.0599 26.6822 38C26.6822 36.0599 25.112 34.4877 23.1743 34.4877C25.112 34.4877 26.6822 32.9155 26.6822 30.9753Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_203_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1902 30.9753H28.7876V38H30.1902V30.9753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7874 30.9753H27.3848V38H28.7874V30.9753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3848 30.9753H25.9822V38H27.3848V30.9753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9795 30.9753H24.5769V38H25.9795V30.9753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5769 30.9753H23.1743V38H24.5769V30.9753Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55623 34.7826V36.1843H0V34.7826H1.58909C1.88637 34.7826 2.10257 34.6988 2.2404 34.5283C2.37823 34.3578 2.4458 34.1034 2.4458 33.7625V22.5219C2.4458 22.1836 2.37553 21.9266 2.2404 21.7588C2.10257 21.5883 1.88367 21.5044 1.58909 21.5044H0V20.1027H6.48879V23.128H6.64824C7.36982 22.1512 8.23193 21.3502 9.23997 20.7251C10.248 20.1 11.3966 19.7861 12.6911 19.7861C14.3667 19.7861 15.6531 20.2651 16.5557 21.2203C17.4557 22.1755 17.907 23.5447 17.907 25.328V33.7977C17.907 34.1386 17.98 34.3876 18.1286 34.5472C18.2773 34.7069 18.4881 34.7854 18.7637 34.7854H20.3852V36.187H11.829V34.7854H12.91C13.1857 34.7854 13.3965 34.7015 13.5451 34.531C13.6938 34.3605 13.7667 34.1062 13.7667 33.7652V24.7841C13.7667 23.8722 13.5478 23.1713 13.1154 22.6815C12.6803 22.1944 12.029 21.9482 11.1588 21.9482C10.2048 21.9482 9.33997 22.2783 8.56704 22.9359C7.79141 23.5934 7.1401 24.3998 6.6104 25.355V33.7625C6.6104 34.1034 6.68337 34.3578 6.83201 34.5283C6.98065 34.6988 7.19145 34.7826 7.46711 34.7826H8.54812H8.55623Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRactangleIcon);
export default __webpack_public_path__ + "static/media/ractangleIcon.cd707f1e8f04e3f36bfbf88357816634.svg";
export { ForwardRef as ReactComponent };